import { Controller } from '@hotwired/stimulus'
import { turboFrame, current } from '../helpers'
import { formsProjectSchedulesPath } from '../routes'

const SCHEDULES_FRAME_ID = 'forms_schedules'

export default class extends Controller {
  static values = { formId: String }

  selectDestination ({ detail: { projectId, target } }) {
    if (target !== 'schedule') return
    this.removeSchedules()
    if (projectId) this.insertSchedulesFrame(projectId)
  }

  // Private

  insertSchedulesFrame (projectId) {
    const schedulesFrame = turboFrame(
      SCHEDULES_FRAME_ID,
      formsProjectSchedulesPath(current.account.id, projectId, { form_id: this.formIdValue }),
      { class: 'block' }
    )
    this.element.appendChild(schedulesFrame)
  }

  removeSchedules () {
    document.getElementById(SCHEDULES_FRAME_ID)?.remove()
  }
}
